export const LOGIN_INPUT_CLASSES =
  '[&_[data-slot=input]]:[--input-text:var(--color-neutral-0)] [&_[data-slot=input]]:bg-opacity-light-5 [&_[data-slot=input][data-error=false]:not(:hover)]:border-opacity-light-20 [&_[data-slot=input]]:placeholder:text-opacity-light-50';

export const LOGIN_SUBMIT_BUTTON_CLASSES =
  'rounded-xs w-full disabled:!bg-opacity-light-10 disabled:!text-opacity-light-30 disabled:!border-none';
